import { FC } from 'react'
import { GovernmentJobTitle, GovernmentJobTitleTinyDto } from '../../../../types'
import { Select, Tooltip } from 'antd'
import { FormikSelect } from '../../../../components/formik-component/Select'
import { MULTI_VALUE_SEPARATOR } from '../helpers'

const { Option, OptGroup } = Select

interface GovernmentJobTitleSelectProps {
  name: string
  currentGovernmentJobTitle: GovernmentJobTitleTinyDto
  selectableGovernmentJobTitles: GovernmentJobTitle[]
  disabled?: boolean
  onChange: (newValue: string) => void
}

type OptionData = {
  label: string
  options: {
    value: string
    label: string
  }[]
}

export const GovernmentJobTitleSelect: FC<GovernmentJobTitleSelectProps> = ({
  name,
  currentGovernmentJobTitle,
  selectableGovernmentJobTitles,
  disabled,
  onChange,
}) => {
  const isEqualToCurrentGovernmentJobTitle = (selectedDepartment: string, selectedTitle: string): boolean => {
    return currentGovernmentJobTitle.department === selectedDepartment && currentGovernmentJobTitle.title === selectedTitle
  }

  const concatGovernmentJobTitleData = (governmentJobTitle: GovernmentJobTitleTinyDto): string => {
    return governmentJobTitle.department.concat(MULTI_VALUE_SEPARATOR).concat(governmentJobTitle.title)
  }

  const createOptions = (): OptionData[] => {
    const departments: string[] = [...new Set(selectableGovernmentJobTitles.map((el: GovernmentJobTitle) => el.department))] as string[]

    const res: OptionData[] = []
    for (const department of departments) {
      res.push({
        label: department,
        options: selectableGovernmentJobTitles
          .filter((el: GovernmentJobTitle) => el.department === department)
          .map((el) => {
            return { value: el.title, label: el.title }
          }),
      })
    }
    return res
  }

  return (
    <FormikSelect
      name={name + '.governmentJobTitle'}
      placeholder={concatGovernmentJobTitleData(currentGovernmentJobTitle)}
      size="small"
      style={{ width: '100%' }}
      allowClear
      onChange={(val: string) => {
        onChange(val)
      }}
      showSearch
      filterOption={(input, option) => {
        return input && option && option.props && option.props.label.toLowerCase().includes(input.toLowerCase()) ? true : false
      }}
      disabled={disabled}
    >
      {createOptions().map((opt, index) => (
        <OptGroup key={index} label={opt.label}>
          {opt.options.map((el) => (
            <Option
              key={opt.label.concat(MULTI_VALUE_SEPARATOR).concat(el.value)}
              value={currentGovernmentJobTitle.hiringOfficeCode
                .concat(MULTI_VALUE_SEPARATOR)
                .concat(opt.label)
                .concat(MULTI_VALUE_SEPARATOR)
                .concat(el.value)}
              label={el.value}
              disabled={isEqualToCurrentGovernmentJobTitle(opt.label, el.label)}
            >
              <Tooltip title={el.label}>{el.label}</Tooltip>
            </Option>
          ))}
        </OptGroup>
      ))}
    </FormikSelect>
  )
}
